import notFound from "@/public/404.svg";
import adharDetails from "@/public/aadhar_verification.svg";
import aadharcode from "@/public/aadharcode.svg";
import aadharkyc from "@/public/aadharkyc.svg";
import ackoLogo from "@/public/acko-logo.svg";
import appliedLoanTag from "@/public/applied_amount_tag.svg";
import applogo from "@/public/applogo.svg";
import authError from "@/public/auth_error.svg";
import authenticationError from "@/public/authentication_error.svg";
import backArrow from "@/public/back_arrow.svg";
import bank from "@/public/bank.svg";
import bankVerificationError from "@/public/bankError.svg";
import jobLossIcon from "@/public/briefcase.svg";
import buddyLoan from "@/public/buddy_loan.svg";
import building from "@/public/Building.svg";
import businessBanner from "@/public/business-banner.jpg";
import calendarIcon from "@/public/calendar_today.svg";
import carBanner from "@/public/car-banner.jpg";
import walletCard from "@/public/card.svg";
import chargePhone from "@/public/charge_phone.svg";
import check from "@/public/check.svg";
import checkIcon from "@/public/check_icon_filled_dark.svg";
import chrome from "@/public/chrome.svg";
import clock from "@/public/clock.svg";
import close from "@/public/Close.svg";
import confettiCone from "@/public/confetti_cone.svg";
import congratulations from "@/public/congratulations.svg";
import consentApp from "@/public/consent_app.svg";
import consentLocation from "@/public/consent_location.svg";
import consentStorage from "@/public/consent_storage.svg";
import consumerDurables from "@/public/consumer_durables.svg";
import contactid from "@/public/contactid.svg";
import creditMantri from "@/public/credit_mantri.svg";
import creditTracker from "@/public/credit_tracker.svg";
import cross from "@/public/cross.svg";
import adharNumberVerification from "@/public/digi_locker.svg";
import disabilityIcon from "@/public/disability.svg";
import document from "@/public/document.svg";
import edge from "@/public/edge.svg";
import emailSent from "@/public/email_sent.svg";
import emiCalculator from "@/public/emi_calculator.svg";
import empathizeLine from "@/public/empathize-line.svg";
import faceMismatch from "@/public/face_mismatch.svg";
import faceNotVerified from "@/public/face_not_verified.svg";
import faceVerification from "@/public/face_verification.svg";
import finboxIcon from "@/public/finbox_icon.svg";
import fingerprint from "@/public/fingerprint.svg";
import firefox from "@/public/firefox.svg";
import globe from "@/public/globe.svg";
import goodLighting from "@/public/good_lighting.svg";
import greenStar from "@/public/green_star.svg";
import hatGlass from "@/public/hat_glass.svg";
import hdfcLifeInsuranceLogo from "@/public/hdfc-logo.svg";
import hdfcInsurance from "@/public/hdfc_insurance.svg";
import healthPlan from "@/public/health_plan.svg";
import heartIcon from "@/public/heart.svg";
import hero from "@/public/hero.svg";
import heroLeft from "@/public/hero_left.svg";
import heroRight from "@/public/hero_right.svg";
import heroShieldGreen from "@/public/heroShieldGreen.svg";
import navlogo from "@/public/hipl.svg";
import navlogo2 from "@/public/hipl2.svg";
import homeLocation from "@/public/home_location_Icon.svg";
import homeLocationPin from "@/public/home_location_pin.svg";
import hospitalIcon from "@/public/hospital.svg";
import location from "@/public/ic_location.svg";
import phone from "@/public/ic_phone.svg";
import infoIconDarkGreen from "@/public/info_dark_green.svg";
import infoGreen from "@/public/info_green.svg";
import instantpersonalloanlogo from "@/public/instant_personal_loan_logo.svg";
import insurance from "@/public/insurance.svg";
import labTest from "@/public/lab-test.svg";
import leftWindow from "@/public/left_window.svg";
import lighting from "@/public/lighting.svg";
import loanCoverage from "@/public/loan-coverage.svg";
import loanSettled from "@/public/loan-settled.svg";
import loanCancellation from "@/public/loan_cancellation.svg";
import loanhand from "@/public/loanhand.svg";
import locationPin from "@/public/location_pin.svg";
import loginBackground from "@/public/login-background.svg";
import loginBanner from "@/public/login-banner.svg";
import orgLogo from "@/public/login-logo.svg";
import logout from "@/public/logout.svg";
import mandate from "@/public/mandate.svg";
import mandatory from "@/public/mandatory.svg";
import mapPin from "@/public/map_pin.svg";
import mediBuddyLogo from "@/public/mediBuddy-logo.svg";
import medicalLoan from "@/public/medical_loan.svg";
import medicineBottle from "@/public/medicine-bottle-line.svg";
import message from "@/public/message.svg";
import microscope from "@/public/microscope.svg";
import moneyGroup from "@/public/money_sack.svg";
import nameMismatchFound from "@/public/name_mismatch.svg";
import nameMismatchError from "@/public/name_mismatch_error.svg";
import coinsLeft from "@/public/coins-left.svg";
import coinsRight from "@/public/coins-right.svg";
import dataProtection from "@/public/data_protection.svg";
import navbarLogo from "@/public/navlogo.svg";
import noHatGlass from "@/public/no_hat_glass.svg";
import noInternet from "@/public/no_internet.svg";
import noOffer from "@/public/no_offer.svg";
import noService from "@/public/no_service.svg";
import noteLight from "@/public/note_light.svg";
import notification from "@/public/notification.svg";
import unlockOffer from "@/public/offer_footer_card.png";
import offerTick from "@/public/offer_tick.svg";
import oneMoney from "@/public/onemoney.png";
import openapp from "@/public/open_app.svg";
import orangeStar from "@/public/orange_star.svg";
import panAadharLinking from "@/public/pan_aadhaar_illustration.png";
import editIcon from "@/public/pencil-icon.svg";
import percentage from "@/public/percentage.svg";
import doctorIcon from "@/public/person-icon.svg";
import person from "@/public/person.svg";
import phoneLock from "@/public/phone_lock.svg";
import picture from "@/public/picture.svg";
import popularChoice from "@/public/popular_choice.svg";
import preApprovedOffers from "@/public/pre_approved.svg";
import qrCode from "@/public/qr_code.svg";
import quicktime from "@/public/quicktime.svg";
import rbiBanner from "@/public/rbi-banner.jpg";
import recommenedTag from "@/public/recommended_tag.svg";
import rejectedLoan from "@/public/rejected-loan.svg";
import safari from "@/public/safari.svg";
import sbi from "@/public/sbi.svg";
import scheduledMaintenance from "@/public/scheduled_maintenance.svg";
import serviceUnavailable from "@/public/service_unavailable.svg";
import shield from "@/public/shield.svg";
import burdenFreeIcon from "@/public/stay-burden-free.svg";
import stepdivider from "@/public/stepdivider.svg";
import stepdividerKyc from "@/public/stepdividerKyc.svg";
import stethoscopeIcon from "@/public/stethoscope.svg";
import stethoscopeLine from "@/public/stethoscopeLine.svg";
import surakshaIcon from "@/public/suraksha-icon.svg";
import surakshaIconLight from "@/public/suraksha_icon_light.svg";
import techinalIssues from "@/public/technical_issue.svg";
import verified from "@/public/verified.svg";
import vkycFail from "@/public/vkyc_fail.svg";
import webCam from "@/public/webcam.svg";
import webServerMaintenance from "@/public/webServermaintenance.svg";
import whatsApp from "@/public/whatsAppIcon.svg";
import whiteBank from "@/public/white_bank.svg";
import whiteFinger from "@/public/white_finger.svg";
import whiteStar from "@/public/white_star.svg";
import wifi from "@/public/wifi.svg";
import yellowBulb from "@/public/yellow_bulb.svg";
import edgebravefirfox from "/public/edgebravefirfox.svg";
import infoIcon from "/public/info_icon.svg";
import panMismatch from "/public/pan_mismatch.svg";
import qrBox from "/public/qr_box.svg";
import radiodot from "/public/radiodot.svg";
import recommended from "/public/recommended.svg";
import safariscreen from "/public/safariscreen.svg";
import samsungbrowser from "/public/samsungbrowser.svg";
import skipCkyc from "/public/skip_kyc.svg";
import threelines from "/public/threelines.svg";
import threelinesgear from "/public/threelinesgear.svg";
import toggleswitch from "/public/toggleswitch.svg";
import trusted from "/public/trusted.svg";
import attemptError from "@/public/attempt_error.svg";
import otpvarification from "@/public/otpvarification.svg";
import fail from "@/public/fail.svg";
import personalLoanIcon from "/public/personal-loan.svg";
import twoWheelerLoanIcon from "/public/two-wheeler-loan.svg";
import usedCarLoanIcon from "/public/used-car.svg";
import unsecuredBussLoanIcon from "/public/unsecured-bussiness-loan.svg";
import scaleWrapperAvatarIcon from "/public/scale-wrapper-avatar.svg";
import crifLogo from "/public/Crif_logo.svg";
import coinGroupIcon from "@/public/coin-group.svg";
import creditRefreshIcon from "@/public/refresh-line.svg";
import securedDataImg from "@/public/secured-data.svg";
import manCheckCreditImg from "@/public/home_credit_icon.svg";
import addressVerification from "@/public/addressVerification.svg";
import finalReport from "@/public/finalReport.svg";
import starcheck from "@/public/starcheck.svg";
import documentVerification from "@/public/documentVerification.svg";
import televerification from "@/public/televerification.svg";
import moneyBagWithCoins from "@/public/moneyBagWithCoins.svg";
import logoutLoan from "@/public/logoutLoan.svg";
import addressMapPin from "@/public/addressMapPin.svg";
import claimNowIIcon from "@/public/claimnowicons.svg";
import preApprovedIcon from "@/public/Pre-approved.svg";
import personalizedIcon from "@/public/Personalized.svg";
import abolutalyFreeIcon from "@/public/AbsolutelyFree.svg";
import secureIcon from "@/public/secure.svg";
import congratsIcon from "@/public/congratsicon.svg";
import waivedoff from "@/public/waivedoff.svg";
import creditScoreHomeImage from "@/public/homescreen_creditscore_img.svg";
import starIcon from "@/public/staricon.png";
import bharatPe from "@/public/bharatpe.svg";
import switchMyLoan from "@/public/creadylogo.svg";
import upgradeOfferBackground from "@/public/upgrade-offer-background.svg";
import protectionPlanIcon from "@/public/protection_plan.svg";
import calendarInsuranceIcon from "@/public/calendar_insurance.svg";
import coveredLoanInsuranceIcon from "@/public/covered_loan_insurance.svg";
import opdInsuranceIcon from "@/public/opd_insurance.svg";
import protectionShield from "@/public/protection_shield.svg";
import filledCalendarInsuranceIcon from "@/public/calendar_filled.svg";
import filledCoveredLoanInsuranceIcon from "@/public/covered_loan_insurance_filled.svg";
import filledOpdInsuranceIcon from "@/public/opd_insurance_filled.svg";
import bankDark from "@/public/bankDark.svg";
import docIcon from "@/public/docsFrame.svg";
import timerDark from "@/public/timerDark.svg";
import upgradeOfferCoin from "@/public/exclusive-offer.svg";
import exclusiveOfferLabel from "@/public/exclusive-upgrade-label.svg";
import cpAdvisor from "@/public/cpadvisor.svg";
import verifyViaOtp from "@/public/verifyViaOtp.svg";
import chooseMultipleBankAccounts from "@/public/chooseMultipleBankAccounts.svg";
import fetchingLinkedAccounts from "@/public/fetchingLinkedAccounts.svg";
import consentToCheckEligibility from "@/public/consentToCheckEligibility.svg";
import oneMoneyLogo from "@/public/oneMoneyLogo.svg";
import emailVerified from "@/public/email_verified.svg";
import consentAsk from "@/public/ConsentAsk.svg";
import enterOtp from "@/public/EnterOtp.svg";
import pwLogo from "@/public/pw_logo.svg";

//IMAGES
export const IMAGES = {
  sbi,
  bank,
  hero,
  wifi,
  edge,
  phone,
  mapPin,
  chrome,
  safari,
  qrCode,
  person,
  webCam,
  shield,
  logout,
  navlogo,
  orgLogo,
  location,
  mandatory,
  phone,
  mandate,
  applogo,
  openapp,
  firefox,
  picture,
  location,
  verified,
  loanhand,
  navlogo2,
  whatsApp,
  oneMoney,
  notFound,
  mandatory,
  infoIcon,
  heroLeft,
  lighting,
  hatGlass,
  document,
  infoGreen,
  heroRight,
  backArrow,
  emailSent,
  offerTick,
  whiteBank,
  buddyLoan,
  noteLight,
  greenStar,
  carBanner,
  authError,
  rbiBanner,
  insurance,
  aadharkyc,
  quicktime,
  phoneLock,
  noHatGlass,
  percentage,
  aadharcode,
  healthPlan,
  navbarLogo,
  noInternet,
  leftWindow,
  yellowBulb,
  message,
  globe,
  contactid,
  finboxIcon,
  orangeStar,
  consentApp,
  locationPin,
  loginBanner,
  unlockOffer,
  stepdivider,
  whiteFinger,
  fingerprint,
  chargePhone,
  notification,
  homeLocation,
  confettiCone,
  goodLighting,
  rejectedLoan,
  recommenedTag,
  hdfcInsurance,
  emiCalculator,
  creditTracker,
  techinalIssues,
  consentStorage,
  businessBanner,
  appliedLoanTag,
  stepdividerKyc,
  homeLocationPin,
  faceNotVerified,
  congratulations,
  loginBackground,
  consentLocation,
  loanCancellation,
  nameMismatchError,
  preApprovedOffers,
  authenticationError,
  webServerMaintenance,
  panAadharLinking,
  building,
  instantpersonalloanlogo,
  adharNumberVerification,
  faceVerification,
  infoIconDarkGreen,
  editIcon,
  moneyGroup,
  medicalLoan,
  consumerDurables,
  whiteStar,
  popularChoice,
  cross,
  check,
  clock,
  adharDetails,
  adharNumberVerification,
  faceVerification,
  ackoLogo,
  disabilityIcon,
  heartIcon,
  hospitalIcon,
  jobLossIcon,
  walletCard,
  labTest,
  loanCoverage,
  loanSettled,
  doctorIcon,
  stethoscopeIcon,
  burdenFreeIcon,
  hdfcLifeInsuranceLogo,
  mediBuddyLogo,
  surakshaIconLight,
  calendarIcon,
  infoIconDarkGreen,
  stethoscopeLine,
  microscope,
  medicineBottle,
  empathizeLine,
  checkIcon,
  surakshaIcon,
  close,
  vkycFail,
  edgebravefirfox,
  bankVerificationError,
  samsungbrowser,
  creditMantri,
  heroShieldGreen,
  recommended,
  panMismatch,
  skipCkyc,
  threelines,
  radiodot,
  safariscreen,
  toggleswitch,
  threelinesgear,
  qrBox,
  trusted,
  coinsLeft,
  coinsRight,
  noOffer,
  noService,
  scheduledMaintenance,
  serviceUnavailable,
  faceMismatch,
  nameMismatchFound,
  dataProtection,
  attemptError,
  otpvarification,
  fail,
  personalLoanIcon,
  twoWheelerLoanIcon,
  usedCarLoanIcon,
  unsecuredBussLoanIcon,
  scaleWrapperAvatarIcon,
  crifLogo,
  coinGroupIcon,
  creditRefreshIcon,
  securedDataImg,
  manCheckCreditImg,
  addressVerification,
  finalReport,
  starcheck,
  documentVerification,
  televerification,
  moneyBagWithCoins,
  logoutLoan,
  addressMapPin,
  waivedoff,
  claimNowIIcon,
  preApprovedIcon,
  personalizedIcon,
  abolutalyFreeIcon,
  secureIcon,
  congratsIcon,
  creditScoreHomeImage,
  starIcon,
  bharatPe,
  switchMyLoan,
  upgradeOfferBackground,
  protectionPlanIcon,
  calendarInsuranceIcon,
  coveredLoanInsuranceIcon,
  opdInsuranceIcon,
  protectionShield,
  filledCalendarInsuranceIcon,
  filledCoveredLoanInsuranceIcon,
  filledOpdInsuranceIcon,
  bankDark,
  docIcon,
  timerDark,
  upgradeOfferCoin,
  exclusiveOfferLabel,
  cpAdvisor,
  verifyViaOtp,
  chooseMultipleBankAccounts,
  fetchingLinkedAccounts,
  consentToCheckEligibility,
  oneMoneyLogo,
  emailVerified,
  consentAsk,
  enterOtp,
  pwLogo,
};
